var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.update)?_c('Masonry',{attrs:{"title":"精彩案例","category_path":"case","category_id":_vm.categoryID}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }